export default "__VITE_ASSET__BaKeTgy___"